import { useMemo } from "react";
import { useMyDataQuery } from "@/generated/graphql";
import { shouldShowFreeWatermark } from "@/lib/watermark/shouldShowFreeWatermark";

/** True when the free-plan watermark should be shown in previews. */
export const useShowWatermark = (): boolean => {
  const { data: myData } = useMyDataQuery();
  const features = myData?.myData?.subscription?.plan?.features;
  return useMemo(() => shouldShowFreeWatermark(features), [features]);
};
